<script setup lang="ts">
//import { AsyncCoinWidget } from '@/components/widget/AsyncCoinWidget'
import CoinWidget from '@/components/widget/CoinWidget.vue';
import WinPopup from '@/components/widget/WinPopup.vue';
import { playerWin, campaign } from '@/core/Model';
//import CoinImg from './components/widget/CoinImg.vue';

import { onMounted, computed } from 'vue';
import { isLoaded, isActive, isEnabled, isUiOverlapped } from '@/core/AppStatus';

import { emit } from '@/utils/GlobalEventDispatcher';

import { INTERNAL_EVENTS } from '@/core/AppStatus';

const showWinWidget = computed(() => {
	const result = playerWin.value !== null && isEnabled.value;
	// console.log('show win widget:', result);
	return result;
});

const isEnabledComputed = computed(() => {
	return !showWinWidget.value && isEnabled.value;
});

const campaingTitle = computed(() => {
	return campaign.value?.public_name ?? 'TEST CAMPAIGN';
});
const skin = computed(() => {
	return campaign.value?.skin ?? 'default';
});

// const handleClick = () => {
//   coinSprite.value?.run()
// }

// const handleAnimationEnd = () => {
//   console.log('Animation ended')
// }

const confirmPlayerWin = () => {
	// console.log('confirmPlayerWin');
	emit(INTERNAL_EVENTS.CONFIRM_PLAYER_WIN);
	//showWinWidget.value = false;
};

onMounted(() => {
	// console.log('app onMounted:', isActive.value);
});
</script>

<template>
	<div v-if="isLoaded">
		<!-- <button  class="fixed bottom-0 left-0 z-[1001] bg-blue-500 text-white p-2 rounded-lg pointer-events-auto" @click="overlayHandler">Overlay</button> -->
		<WinPopup
			v-if="showWinWidget"
			:playerWin="playerWin"
			:campaingTitle="campaingTitle"
			:skin="skin"
			@confirmPlayerWin="confirmPlayerWin"
		/>

		<!-- <CoinWidget v-if="isActive" :enabled="isEnabled" :campaing="campaign || null" /> -->
		<!-- <CoinWidget v-if="isActive" :enabled="isEnabled" /> -->
		<!-- <CoinWidget v-if="!isUiOverlapped && isActive" :enabled="isEnabledComputed" /> -->
		<CoinWidget v-show="!isUiOverlapped && isActive" :enabled="isEnabledComputed" />
	</div>
</template>
